import React from 'react';
import moment from 'moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import "./PagamentosTable.css";

const PagamentosTable = ({ listCanals, onRemove, onExport }) => {
  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th className="text-muted">Data</th>
          <th className="text-muted">Forma de pagamento</th>
          <th className="text-muted">Valor</th>
          <th className="text-muted">Bônus</th>
          <th className="text-muted">Identificador</th>
          <th className="text-muted">Status</th>
          <th className="text-muted">Detalhes da transação</th>
          <th className="text-muted">Excluir</th>
        </tr>
      </thead>
      <tbody>
        {listCanals.map((canal, index) => (
          <tr key={index}>
            <td>{moment(canal?.data)?.format("DD/MM/YYYY HH:mm:ss")}</td>
            <td>{String(canal?.tipo || "").trim().toLowerCase() === "bank_transfer" || String(canal?.tipo || "") === "11" || String(canal?.tipo || "").trim().toLowerCase() === "pix"
            ? "PIX"
            : String(canal?.tipo || "").trim().toLowerCase() === "cash" || String(canal?.mercadoPagoId || "").trim().toLowerCase() === "cash"
            ? "Especie"
            : String(canal?.tipo || "").trim().toLowerCase() === "account_money" || String(canal?.tipo || "").trim().toLowerCase() === "conta mercado pago"
            ? "Conta Mercado Pago"
            : String(canal?.tipo || "").trim().toLowerCase() === "debit_card" || String(canal?.tipo || "").trim().toLowerCase() === "8"
            ? "Débito"
            : String(canal?.tipo || "").trim().toLowerCase() === "credit_card"
            ? "Crédito"
            : String(canal?.tipo || "").trim().toLowerCase() === "prepaid_card"
            ? "Crédito"
            : String(canal?.tipo || "").trim().toLowerCase() === "1"
            ? "Crédito"
            : String(canal?.tipo || "").trim().toLowerCase() === "saida_produto"
            ? "Saída de Produto"
            : "-"}</td>
            <td>{new Intl.NumberFormat("pt-BR", {
            style: "currency",
            currency: "BRL",
            }).format(canal?.valorAcumulado? canal?.valorAcumulado: canal?.valor)}
            </td>
            <td>
              {canal?.valorBonus > 0 ? (
                <span className="badge bg-info text-dark">
                  +{canal.valorBonus} pulsos
                </span>
              ) : (
                <span className="text-muted">-</span>
              )}
            </td>
            <td>{canal?.mercadoPagoId}</td>
            <td>
                <OverlayTrigger
                    key={canal.key}
                    placement="bottom"
                    popperConfig={{ modifiers: [{ name: "preventOverflow", enabled: false }] }}
                    overlay={
                    <Tooltip id={`tooltip-top-${canal.key}`} style={{ zIndex: 1050 }}>
                        {canal?.motivoEstorno
                        ? canal?.motivoEstorno
                        : "Sem motivo registrado"}
                    </Tooltip>
                    }
                >
                    <span
                        className={`badge ${
                            canal?.estornado
                            ? "bg-danger text-dark"
                            : canal?.status === "PENDENTE"
                            ? "bg-warning text-dark"
                            : "bg-success"
                        }`}
                    >
                        {canal?.estornado ? "Estornado" : canal?.status === "PENDENTE" ? "Pendente" : "Recebido"}
                    </span>
                </OverlayTrigger>
            </td>
            <td>
              {(canal?.tipo === "CASH" || canal?.mercadoPagoId === "CASH" || canal?.mercadoPagoId === "saiu premio") ? (
                <span className="text-muted">-</span>
              ) : typeof onExport === "function" ? (
                <button
                  className="btn btn-secondary btn-sm"
                  onClick={() => onExport(canal)}
                >
                  Exportar PDF
                </button>
              ) : (
                <span className="text-muted">-</span>
              )}
            </td>
            <td>
              <button
                className="btn btn-danger btn-sm"
                onClick={() => onRemove(canal)}
              >
                Remover
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default PagamentosTable;
